import { render } from "./commonNumber.vue?vue&type=template&id=0aa38608&ts=true"
import script from "./commonNumber.vue?vue&type=script&setup=true&lang=ts"
export * from "./commonNumber.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/shared/commonControls/commonNumber.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0aa38608"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0aa38608', __exports__)) {
    api.reload('0aa38608', __exports__)
  }
  
  module.hot.accept("./commonNumber.vue?vue&type=template&id=0aa38608&ts=true", () => {
    api.rerender('0aa38608', render)
  })

}


export default __exports__